// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    nextMode: {
        id: 'mode-selector.next-mode',
        defaultMessage: 'Next mode'
    },
    previousMode: {
        id: 'mode-selector.previous-mode',
        defaultMessage: 'Previous mode'
    },
    purpose: {
        id: 'mode-selector-slide.purpose',
        defaultMessage: 'Mode Selector'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-slide/intl.js